import { createAsyncCategoryHandler } from "../category-dispatcher";
import { screenInputTools } from "./screen-input-tools";

/**
 * Category handler for screen input operations.
 *
 * Reads are sync; every WRITE is async because it resolves on the persist rather
 * than on the in-memory patch. Screen inputs live in `publicMetaData` (the
 * PublicJSON column), which the late `loadProject` setState replaces — so a write
 * that returned before its save could be, and was, silently discarded while
 * reporting `{ok: 1}` (session 25c5e8e8, four screens).
 */
export const handleScreenInputCategory = createAsyncCategoryHandler(
  {
    list: screenInputTools.sync!.ui_structure_list_screen_inputs,
    // KOA-18173 — read-only consumer evidence for the spurious-input prune.
    usage: screenInputTools.sync!.ui_structure_screen_input_usage
  },
  {
    create: screenInputTools.async!.ui_structure_create_screen_input,
    update: screenInputTools.async!.ui_structure_update_screen_input,
    delete: screenInputTools.async!.ui_structure_delete_screen_input
  }
);
